var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGaWide(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#1EA5FC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 40c5.799 0 10.5-4.701 10.5-10.5S45.799 19 40 19s-10.5 4.701-10.5 10.5S34.201 40 40 40zM46.93 43.36l-1.47 13.02L42.1 46.3l2.1-2.73c.42-.63-.21-1.47-1.05-1.47h-4.2c-.84 0-1.26.84-1.05 1.47l1.89 2.73-3.36 10.08-1.68-13.65C26.77 45.25 21.1 52.39 21.1 61h37.8c0-7.98-5.04-14.91-11.97-17.64zM31.6 56.8h-4.2v-3.15c0-.63.42-1.05 1.05-1.05h2.1c.63 0 1.05.42 1.05 1.05v3.15z",
    fill: "#fff"
  })));
}

export default SvgGaWide;